<template>
  <div>

    <div style="padding: 2px" v-if="!$route.params.tripTypes||$route.params.tripTypes=='transfers'">
      <TripTypeSelector v-model="selectedTypes" :single-trips="singleTrips"/>
    </div>
    <!--    <transition name="fade" mode="out-in">-->
    <!--      <div class="text-white bg-red q-pa-xs" v-if="problems">-->
    <!--        <q-btn v-for="(pax,cd) in problems" :key="cd"    :icon="warnIcons[cd]"-->
    <!--               dense xsize="sm" @click="routeGo({query:{mode:'warnings'}})" :title="cd+' '+pax+' issues'">-->
    <!--         {{pax}}-->
    <!--        </q-btn>-->

    <!--      </div>-->
    <!--    </transition>-->
    <!--            ==={{ selectedTypes }}-->
    <template v-if="!simple">
      <q-btn-toggle
          v-model="groupMode"
          spread

          :dark="themeCtx=='dark'"
          toggle-color="primary"
          :options="[
          {label: 'Flights/Trips', value: 'flights'}, {label: 'Companies', value: 'companies'},
        ]"/>
      <div
          v-fill-height="20"
          style="margin-top: 10px" >
        <q-checkbox
            @input="toggleAll()"
            v-model="allTicked"></q-checkbox>
        <q-tree
            ref="bookTree"
            :dark="themeCtx=='dark'"
            v-if="pivotData.length"
            :nodes="pivotData"
            tick-strategy="leaf"
            node-key="_id"
            children-key="items"
            xchildren-key="_id"
            label-key="text"
            :selected.sync="selected"
            :ticked.sync="ticked"
            :expanded.sync="expanded">
          <template v-slot:default-header="prop">
            <div v-if="prop.node._groupProp=='tourCoId'">
              {{ prop.node._sample.coname ? prop.node._sample.coname : prop.node._sample.cocode }}
              <span class="material-icons">groups</span>
              <small>{{ prop.node.pax }}/{{ prop.node.pax_boarded }}</small>
            </div>
            <div v-else>
              <small>{{ prop.node._sample.trip_time_human }}</small>
              {{ prop.node._sample.for_trip }} <i
                v-if="prop.node._sample.tripType=='DEP'"
                class="material-icons label-danger"
                xstyle="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">flight_takeoff</i>
              <i
                  v-else-if="prop.node._sample.tripType=='ARV'"
                  class="material-icons label-success"
                  xstyle="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">flight_land</i>
              <i
                  v-else
                  class="material-icons label-warning"
                  xstyle="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">directions_boat</i>
              <small>{{ prop.node.pax }}/{{ prop.node.pax_boarded }}</small>
            </div>


          </template>
        </q-tree>
      </div>
    </template>
  </div>
</template>

<script>
import funs_transfers from "../../mixins/funs_transfers";
import TripTypeSelector from "../Page/TRIPS/TripTypeSelector.vue";

let ticked_stmp = null

export default {
  name: "BookingsSelector",
  components: {TripTypeSelector},
  mixins: [funs_transfers],
  props: {
    // propagate: {type: Object, default: () => ({
    //     selectedTypes:{query:'selectedTypes'}
    //   })},
    singleTrips: {type: Boolean, default: false},
    simple: {type: Boolean, default: false},
    transferData: {type: Array, default: () => []},
    routeData: {type: Boolean, default: false}
  },
  created() {

    //  this.tripOptions = this.tripOptions.filter(opt => !this.$route.params.trips || this.$route.params.trips.indexOf(opt.value) >= 0)
    if (this.tripOptions.length === 1)
      this.selectedTypes = this.tripOptions[0].value

  },
  data() {
    return {
      allTicked: false,
      xgroupMode: 'flights',
      selected: null, xticked: [], expanded: [], xselectedTypes: [],
      // warnIcons:{
      //   _time_not_set_:'departure_board',
      //   _trip_time_excess_:'history',
      //   _not_scheduled_time_:'manage_history',
      //   _time_conflicts_:'running_with_errors',
      //   _route_check_:'more_time'
      // },
      tripOptions: [{
        value: 'DEP',
        label: 'DEP',
        icon: 'room_service',
        color: 'teal'
      },
        {
          value: 'ARV',
          label: 'ARV',
          icon: 'restaurant_menu'
        },
        {
          label: 'ARV/DEP',
          value: 'ARV,DEP',
          icon: 'restaurant_menu'
        },
        {
          value: 'EXCRS',
          label: 'EXCRS',
          icon: 'photo',
          color: 'teal'
        },
        {
          value: 'PICKUP',
          label: 'PkP',
          icon: 'photo',
          color: 'teal'
        }
      ]
    }
  },
  watch: {

    groupMode(v, vo) {
      if (v == vo) return
      this.allTicked = false
      this.ticked = null
    },
    ticked(v) {
      if (!v && !ticked_stmp) return
      const curent_stmp = v ? JSON.stringify(v) : null
      if (curent_stmp == ticked_stmp) return;
      ticked_stmp = curent_stmp
      let selected_companies = [], selected_trips = []
      this.ticked.forEach(tick => {
        const tick_prts = tick.split('||')
        if (this.groupMode == 'flights') {
          if (selected_trips.indexOf(tick_prts[0]) < 0) selected_trips.push(tick_prts[0])
          if (selected_companies.indexOf(tick_prts[1]) < 0) selected_companies.push(tick_prts[1])
        } else {
          if (selected_companies.indexOf(tick_prts[0]) < 0) selected_companies.push(tick_prts[0])
          if (selected_trips.indexOf(tick_prts[1]) < 0) selected_trips.push(tick_prts[1])
        }

      })

      this.$emit('select', {selected_trips: selected_trips, selected_companies: selected_companies})

    }
  },
  methods: {
    toggleAll() {
      const theTree = this.$refs.bookTree
      let toggleNodes = []
      // this.allTicked=!this.allTicked
      this.pivotData.forEach(nd => {
        toggleNodes.push(nd._id)
        if (nd.items) nd.items.forEach(snd => toggleNodes.push(snd._id))
        _log_('nd..nd.....', nd)

      })
      _log_('nd.....', toggleNodes)
      theTree.setTicked(toggleNodes, this.allTicked)
    },
    resetFilters() {
      this.selectedTypes = null
      this.ticked = null
      this.groupMode = null
    }
  },
  computed: {
    selectedTypes: {
      get() {
        // if (this.$route.query.trip_types) return this.$route.query.trip_types
        return this.$route.params.trips
        // else {
        //   this.routeGo({query: {trip_types: this.options[0].value}})
        //   return this.options[0].value
        // }
      },
      set(v) {
        this.routeGo({params: {trips: v ? v : null, booking_filter: null}})
        // this.routeGo({query: {trip_types: v ? v : null, booking_filter: null}})
        // return moment().format("DD/MM/YYYY")
      }
    },
    groupMode: {
      get() {
        if (this.$route.query.filter_mode) return this.$route.query.filter_mode
        return 'flights'
      },
      set(v) {
        this.routeGo({query: {filter_mode: v}})
        // return moment().format("DD/MM/YYYY")
      }
    },
    ticked: {
      get() {
        if (this.$route.query.booking_filter) return this.$route.query.booking_filter.split(',')
        return []
      },
      set(v) {
        // _log_('selected_level_1xxx', v)
        this.routeGo({query: {booking_filter: v ? v.join(',') : null}})
        // return moment().format("DD/MM/YYYY")
      }
    },
    // problems() {
    //   if (!this.transferData?.length) return null
    //   let o = {}
    //   this.transferData.forEach(it => {
    //
    //     if (!!it._warnings && it._warnings != 'dismiss' && _.isObject(it._warnings)) {
    //
    //       for (const warningsKey in it._warnings)
    //         o[warningsKey] = (o[warningsKey] || 0) + 1;
    //     }
    //   })
    //   // _log_('transferData.forEach...',o)
    //   return Object.keys(o)?.length ? o : null
    // },
    pivotData() {

      let allBks = []
      if (!this.transferData) return []
      if (this.routeData !== false)
        this.transferData.forEach(rt => {

          if (!rt.bookings) {
            // _log_('transferData', rt)
            allBks.push({
              flight: rt.flight,
              for_trip: rt.flight ? rt.flight : (rt.gofor + ':' + rt.details),
              tripid: rt.flight ? rt.flight : (rt.gofor + ':' + rt.details),
              cocode: rt.rt_co_code,
              pax: rt.pax,
              routeNum: rt.routename,
              tripType: 'EXCRS',
              tourCoId: rt.coid,
              _route: true
            })
          } else allBks = allBks.concat(rt.bookings)
        })
      else allBks = this.transferData
      allBks = allBks.filter(bk => {
        // _log_('rt.bookings,', bk.tripType)
        let wTriptTypes = this.selectedTypes?.split(',');
        return !this.selectedTypes || wTriptTypes.includes(bk.tripType)
        // return !this.selectedTypes.length || this.selectedTypes.indexOf(bk.tripType) >= 0
      })
      // _log_('rt.bookings,', this.aggregateTransBookings(allBks, ['flight', 'cocode'], 'items', true))
      const aggregatedTransBookings = this.aggregateTransBookings(allBks, this.groupMode == 'flights' ? ['tripid',
        'tourCoId'] : ['tourCoId',
        'tripid'], 'items', true, this.groupMode == 'flights' ? 'strip_time' : 'coname');
      // _log_('rt.bookings,', aggregatedTransBookings)
      return aggregatedTransBookings
      // return this.aggregateTransBookings(allBks, this.groupMode == 'flights' ? ['for_trip', 'cocode'] : ['cocode', 'for_trip'], 'items', true)
    },
  }
}
</script>

<style scoped>

</style>
